import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Bell, UsersThree, ImageSquare } from "@phosphor-icons/react";

export default function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const ref = useRef(null);
  const nav = useNavigate();

  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => { clearInterval(t); document.removeEventListener("mousedown", onClick); };
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && data.unread > 0) {
      await api.post("/notifications/read", {});
      setData((d) => ({ ...d, unread: 0, notifications: d.notifications.map((n) => ({ ...n, read: true })) }));
    }
  };

  const go = (n) => { setOpen(false); if (n.album_id) nav(`/albums/${n.album_id}`); };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notifications-bell" aria-label="Notifications" onClick={toggle}
        className="relative grid h-9 w-9 place-items-center rounded-full text-[#5C554D] transition-transform hover:scale-105 hover:bg-[#F27A54]/10">
        <Bell size={20} weight={data.unread ? "fill" : "regular"} className={data.unread ? "text-[#F27A54]" : ""} />
        {data.unread > 0 && (
          <span data-testid="notif-unread" className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-[#F27A54] px-1 text-[9px] font-bold text-white">
            {data.unread > 9 ? "9+" : data.unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notifications-panel" className="absolute right-0 z-50 mt-2 w-80 overflow-hidden rounded-2xl border border-[#E5DFD3] bg-white shadow-[0_12px_40px_rgba(44,39,36,0.14)]">
          <div className="border-b border-[#E5DFD3] px-4 py-3">
            <p className="font-display text-sm font-bold text-[#2C2724]">Notifications</p>
          </div>
          <div className="max-h-96 overflow-y-auto">
            {data.notifications.length === 0 ? (
              <p className="px-4 py-8 text-center text-sm text-[#787167]">You're all caught up 🌿</p>
            ) : data.notifications.map((n) => (
              <button key={n.id} data-testid={`notif-${n.id}`} onClick={() => go(n)}
                className="flex w-full items-start gap-3 border-b border-[#F0EBE1] px-4 py-3 text-left transition-colors hover:bg-[#FFF3EC]">
                <span className={`mt-0.5 grid h-8 w-8 shrink-0 place-items-center rounded-full ${n.type === "album_invite" ? "bg-[#2D6A4F]/12 text-[#2D6A4F]" : "bg-[#F27A54]/12 text-[#F27A54]"}`}>
                  {n.type === "album_invite" ? <UsersThree size={16} weight="fill" /> : <ImageSquare size={16} weight="fill" />}
                </span>
                <span className="min-w-0">
                  <span className="block text-sm font-semibold text-[#2C2724]">{n.title}</span>
                  {n.body && <span className="block text-xs text-[#787167]">{n.body}</span>}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
